import React from "react";
import {
  VStack,
  Card,
  CardHeader,
  CardBody,
  Text,
  Heading,
} from "@chakra-ui/react";
import EvaluationTemplateManager from "../EvaluationTemplateManager";
import { useInstitutionConfig } from "./InstitutionConfigContext";

export default function EvaluationsTab() {
  const {
    decodedInstitution,
    institution,
    session,
    getConfig,
  } = useInstitutionConfig();

  return (
    <Card bg="gray.800" borderColor="gray.600">
      <CardHeader>
        <Heading size="md" color="white">Evaluation Templates</Heading>
      </CardHeader>
      <CardBody>
        <VStack spacing={4} align="stretch">
          <Text color="gray.300">
            Control which evaluation form templates are available to instructors at this institution.
          </Text>
          <Text fontSize="sm" color="gray.400">
            Global templates are managed by system administrators. In the future, custom institution-specific templates can be created here.
          </Text>
          <EvaluationTemplateManager
            institution={decodedInstitution}
            onUpdate={() => {
              if (institution && session?.user?.id) {
                getConfig({
                  institution: decodedInstitution,
                  userId: session.user.id
                });
              }
            }}
          />
        </VStack>
      </CardBody>
    </Card>
  );
}
